<ng-container *ngIf="appearance=='legacy'">
    <button class="trigger-btn" (click)="toggleTrigger($event)" type="button" #btnRef cdkOverlayOrigin
        #trigger="cdkOverlayOrigin" [style.border-radius]="borderRadius">
        <div #btnLabelRef class="btn-row">
            <div class="label line-clamp-1 break-all">{{selectedLabel ||customLabel || label}}</div>
            <mat-icon #btnIconRef>expand_more</mat-icon>
        </div>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen"
        (overlayOutsideClick)="menuClickOutside($event)">

        <div class="bubble">
            <ng-scrollbar pointerEventsMethod="scrollbar" appearance="standard"
                [style.height.px]="(selectList.length*31)+30" class="c-scroll sc-select">
                <div class="select-inner">
                    <button *ngFor="let value of selectList" (click)="toggleSelectValue(value._id, value,$event)">
                        <div class="select-row items-center py-1">
                            <span class="filter-list__input input-check pointer-events-none" *ngIf="multiple">
                                <span class="input-check__body">
                                    <input class="input-check__input" type="checkbox" [checked]="value.selected">
                                    <span class="input-check__box"></span>
                                    <app-icon class="input-check__icon" name="check-9x7" size="9x7">
                                    </app-icon>
                                </span>
                            </span>
                            <!-- <div class="icon">
                                <mat-icon class="text-black" [svgIcon]="(multiple && value.selected) || (value._id == control.value)?'select_checked':'select_unchecked_circle'"></mat-icon>
                            </div> -->
                            <span class="text">{{ translateHelper.localize(value?.name) }}</span>
                        </div>
                    </button>
                </div>

            </ng-scrollbar>


        </div>
    </ng-template>

</ng-container>



<ng-container *ngIf="appearance=='filter'">

    <div class="widget-filters__list">
        <div class="widget-filters__item" [class.filter-show_more]="selectList?.length > 5">
            <div class="filter filter--opened" appCollapseItem="filter--opened" #collapse="appCollapseItem">

                <button type="button" class="filter__title" (click)="collapse.toggle()">
                    <span class="me-2">•</span> {{customLabel|| label}}
                    <!-- <img src="assets/svg/filters/collapse_arrow.svg" class="collapse-arrow"> -->
                </button>
                <div class="filter__body" appCollapseContent>
                    <div class="filter__container">

                        <div class="filter-list ">
                            <div class="filter-list__list" [ngClass]="{'show-more':selectList?.length > 5}" #filterList>
                                <label *ngFor="let value of selectList;  trackBy: trackItem" class="filter-list__item"
                                    [ngClass]="
                                {'filter-list__item--disabled':value.count ===0}"
                                    (click)="toggleSelectValue(value._id, value,$event);">
                                    <ng-container *ngIf="value.name">
                                        <span *ngIf="multiple"
                                            class="filter-list__input input-check pointer-events-none">
                                            <span class="input-check__body">
                                                <input [checked]="value.selected" [disabled]="value.count ===0"
                                                    class="input-check__input" type="checkbox">
                                                <span class="input-check__box"></span>
                                                <app-icon class="input-check__icon" name="check-9x7" size="9x7">
                                                </app-icon>
                                            </span>
                                        </span>
                                        <div *ngIf="!multiple" class="filter-list__input">
                                            <div [class.cb-active]="control.value == value._id"
                                                class="cb-radio rounded-full"> </div>
                                        </div>
                                        <span class="filter-list__title">{{ translateHelper.localize(value?.name)
                                            }}</span>
                                        <span class="filter-list__counter">{{ value.count }}</span>
                                    </ng-container>
                                </label>
                            </div>
                            <div class="more-label cursor-pointer" (click)="showMore(filterList)"
                                [class.expanded]="filterList.expanded" *ngIf="selectList?.length > 5">
                                <div><img class="showMore-btn me-2" src="assets/svg/filters/show_more_down.svg"> </div>
                                <a #button>{{filterList.expanded?("showLess"|translate):("showMore"|translate)}}</a>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>